import styled from 'styled-components'

import { Badges } from '@avantstay/backoffice-core'

export const BadgesStyles = styled(Badges)`
  margin-top: 0;
  height: auto;
  flex-wrap: nowrap;

  > div {
    margin-top: 0;
  }
`
